import MuiBox from '@mui/material/Box';
import MuiContainer from '@mui/material/Container';
import MuiDivider from '@mui/material/Divider';
import MuiPaper from '@mui/material/Paper';
import MuiStack from '@mui/material/Stack';
import { wrap } from '../wrap';

export const Box = wrap(MuiBox, 'Box');
export const Container = wrap(MuiContainer, 'Container', { keep: ['maxWidth'] });
export const Divider = wrap(MuiDivider, 'Divider');
export const Paper = wrap(MuiPaper, 'Paper');
export const Stack = wrap(MuiStack, 'Stack');

export { Grid } from './Grid';
export type { GridProps } from './Grid';
